import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared.module';
import { ButtonModule } from '../button/button.module';
import { SelectModule } from '../select/select.module';
import { TextfieldComponent } from '../textfield/textfield.component';
import { ContentPickerComponent } from './content-picker.component';
import { ListViewModule } from '../../list/list-view/list-view.module';
import { ListToolbarModule } from '../../list/list-toolbar/list-toolbar.module';
import { ListPaginatorModule } from '../../list/list-paginator/list-paginator.module';

@NgModule({
    declarations: [
        ContentPickerComponent
    ],
    imports: [
        CommonModule,
        ButtonModule,
        SelectModule,
        SharedModule,
        ListViewModule,
        TextfieldComponent,
        ListToolbarModule,
        ListPaginatorModule,
    ],
    exports: [
        ContentPickerComponent
    ]
})
export class ContentPickerModule { }